import { createContext, useReducer, useMemo } from "react";
import DarkModeReducer from "./darkModeReducer";

const INITIAL_STATE = {
  darkMode: false,
};

export const DarkModeContext = createContext(INITIAL_STATE);

export const DarkModeContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(DarkModeReducer, INITIAL_STATE);

  return (
    <DarkModeContext.Provider value={useMemo(() => ({ darkMode: state.darkMode, dispatch }), [state.darkMode])}>
      {children}
    </DarkModeContext.Provider>
  );
};
